import {
    getStowAssociateMetrics,
    getStowBagMetrics,
    getStowBinMetrics,
    getStowPackageMetrics,
    getNodeResourceData,
    getStowBinMetricsForStowV2, getStowCartMetrics
} from "../resources/StowResource";
import {getInductPackageMetrics} from "../resources/InductResource";
import {publishCount, publishTime} from "../MetricUtility";
import {CYCLE, CYCLE_ID, ERROR_METRIC_SUFFFIX, FALSE, True} from "../constants";
import {
    AssociateMetric,
    InductPackageMetric,
    StowPackageMetric,
    Resource,
    BinMetric,
    BagMetric,
    CartMetric
} from "../enums";

export const LOAD_METRICS_FOR_AISLE_CALL_BEGIN = "LOAD_METRICS_FOR_AISLE_CALL_BEGIN";
export const LOAD_STOW_PACKAGE_METRICS_FOR_AISLE = "LOAD_STOW_PACKAGE_METRICS_FOR_AISLE";
export const LOAD_STOW_BIN_METRICS_FOR_AISLE = "LOAD_STOW_BIN_METRICS_FOR_AISLE";
export const LOAD_STOW_BAG_METRICS_FOR_AISLE = "LOAD_STOW_BAG_METRICS_FOR_AISLE";
export const LOAD_STOW_CART_METRICS_FOR_AISLE = "LOAD_STOW_CART_METRICS_FOR_AISLE";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE = "LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE = "LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE";
export const LOAD_METRICS_FOR_AISLE_CALL_FAILURE = "LOAD_METRICS_FOR_AISLE_CALL_FAILURE";
export const LOAD_NODE_RESOURCE_DATA_FOR_AISLE = "LOAD_NODE_RESOURCE_DATA_FOR_AISLE";
export const LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2 = "LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2";

const metricProcessName = "SCC_STOW_AISLE";

const loadMetricsForAisleCallBegin = () => ({
    type: LOAD_METRICS_FOR_AISLE_CALL_BEGIN
});
const loadNodeResourceDataForAisle = (nodeResourceData) => ({
    type : LOAD_NODE_RESOURCE_DATA_FOR_AISLE,
    nodeResourceData
});

const loadStowBinMetricsForAisleForStowV2= (stowBinMetricsMapForStowV2) => ({
    type: LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2,
    stowBinMetricsMapForStowV2
})
const loadStowPackageMetricsForAisle = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_AISLE,
    stowPackageMetricsMap
});

const loadStowBinMetricsForAisle = (stowBinMetricsMap) => ({
    type: LOAD_STOW_BIN_METRICS_FOR_AISLE,
    stowBinMetricsMap
});

const loadStowBagMetricsForAisle = (stowBagMetricsMap) => ({
    type: LOAD_STOW_BAG_METRICS_FOR_AISLE,
    stowBagMetricsMap
});

const loadStowCartMetricsForAisle = (stowCartMetricsMap) => ({
    type: LOAD_STOW_CART_METRICS_FOR_AISLE,
    stowCartMetricsMap
});

const loadInductPackageMetricsForAisle = (inductPackageMetricsMap) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE,
    inductPackageMetricsMap
});

const loadStowAssociateMetricsForAisle = (stowAssociateMetricsMap) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE,
    stowAssociateMetricsMap
});

const loadMetricsForAisleCallFailure = () => ({
    type: LOAD_METRICS_FOR_AISLE_CALL_FAILURE
});

export const getStowPackageMetricsForAisle =
    (isADTAVisibilityEnabled, isDRSStowVisibilityEnabled, nodeId, cycles, clusters, cycleIds) => {

        const metricName = "getStowPackageMetrics";

    const request = {
        groupBy: Resource.AISLE,
        filters: {
            NODE: [nodeId],
            CLUSTER: clusters
        },
        metrics: [
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.STOW_RATE,
            StowPackageMetric.SCAN_COMPLIANCE,
            StowPackageMetric.PLANNED_COUNT,
            StowPackageMetric.FSAF,
            StowPackageMetric.CURRENT_INDUCTED_COUNT
        ]
    }

    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    if (isADTAVisibilityEnabled) {
        request.metrics.push(StowPackageMetric.CURRENT_STOW_BUFFERED_COUNT)
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForAisleCallBegin());
            const startTime = Date.now();
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            stowPackageMetricsMap["A1"] = {
                "displayLabel": "A1.1A",
                "plannedPackages": 5,
                "stowedPackages": 2,
                "currentInductedPackages": 4,
            }
            stowPackageMetricsMap["A2"] = {
                "displayLabel": "A1.1B",
                "plannedPackages": 6,
                "stowedPackages": 4,
                "currentInductedPackages": 5,
            }
            console.log("stowPackageMetricsMap Aisle: " + JSON.stringify(stowPackageMetricsMap));
            if (stowPackageMetricsMap) {
                dispatch(loadStowPackageMetricsForAisle(stowPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForAisleCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForAisleCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getNodeResourceDataForAisle = (nodeId, nodeResourceType, cluster) => {

    const metricName = "getNodeResourceData";

    const request = {
        nodeId: nodeId,
        filters: {
           CLUSTER: cluster
        },
        nodeResourceType: nodeResourceType
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForAisleCallBegin());
            const startTime = Date.now();
            const nodeResources = await getNodeResourceData(request);
            if (nodeResources) {
                dispatch(loadNodeResourceDataForAisle(nodeResources));
                publishTime(metricProcessName, metricName, startTime);
            }
        } catch (error) {
            dispatch(loadMetricsForAisleCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowBinMetricsForAisle = (nodeId, cycles, clusters, cycleIds) => {

    const metricName = "getStowBinMetrics";

    const request = {
        groupBy: Resource.AISLE,
        filters: {
            NODE: [nodeId],
            CLUSTER: clusters
        },
        metrics: [BinMetric.BINS_COUNT_MISSING_OPEN_BAG]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForAisleCallBegin());
            const startTime = Date.now();
            const stowBinMetricsMap = await getStowBinMetrics(request);
            if (stowBinMetricsMap) {
                dispatch(loadStowBinMetricsForAisle(stowBinMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForAisleCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForAisleCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowBinMetricsForAisleForStowV2 = (nodeId, cycles, clusters, cycleIds) => {

    const metricName = "getStowBinMetrics";

    const request = {
        groupBy: Resource.AISLE,
        filters: {
            NODE: [nodeId],
            CLUSTER: clusters
        },
        metrics: [BinMetric.BINS_COUNT_MISSING_OPEN_BAG]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForAisleCallBegin());
            const startTime = Date.now();
            const stowBinMetricsMap = await getStowBinMetricsForStowV2(request);
            if (stowBinMetricsMap) {
                dispatch(loadStowBinMetricsForAisleForStowV2(stowBinMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForAisleCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForAisleCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowBagMetricsForAisle = (nodeId, cycles, clusters, cycleIds, isStowBreakdownV2Enabled) => {

    const metricName = "getStowBagMetrics";

    const request = {
        groupBy: Resource.AISLE,
        filters: {
            NODE: [nodeId],
            CLUSTER: clusters,

        },
        metrics: [
            BagMetric.USED_BAG_COUNT,
            BagMetric.PLANNED_BAG_COUNT
        ]
    }

    if (isStowBreakdownV2Enabled) {
        request.filters["STOW_BREAKDOWN_V2"] = [True]
    }


    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForAisleCallBegin());
            const startTime = Date.now();
            const stowBagMetricsMap = await getStowBagMetrics(request);
            if (stowBagMetricsMap) {
                dispatch(loadStowBagMetricsForAisle(stowBagMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForAisleCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForAisleCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowCartMetricsForAisle = (nodeId, cycles, clusters, cycleIds, isStowBreakdownV2Enabled) => {

    const metricName = "getStowCartMetrics";

    const request = {
        groupBy: Resource.AISLE,
        filters: {
            NODE: [nodeId],
            CLUSTER: clusters,
        },
        metrics: [
            CartMetric.PLANNED_CART_COUNT,
            CartMetric.OPEN_CART_COUNT,
            CartMetric.MISSING_CART_COUNT
        ]
    }

    if (isStowBreakdownV2Enabled) {
        request.filters["STOW_BREAKDOWN_V2"] = [True]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForAisleCallBegin());
            const startTime = Date.now();
            let stowCartMetricsMap = await getStowCartMetrics(request);
            stowCartMetricsMap["A-1"] = {
                "plannedCarts" : "11",
                "usedCarts": "9",
                "missingCarts": "2"
            }
            console.log("stowCartMetricsMap Aisle: " + JSON.stringify(stowCartMetricsMap));
            if (stowCartMetricsMap) {
                dispatch(loadStowCartMetricsForAisle(stowCartMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForAisleCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForAisleCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getInductPackageMetricsForAisle = (nodeId, cycles, clusters) => {

    const metricName = "getInductPackageMetrics";

    const request = {
        nodeId: nodeId,
        groupBy: "Aisle",
        metricList: [InductPackageMetric.RECEIVED],
        filters: {
            Cluster: clusters
        }
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters["Cycle"] = cycles;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForAisleCallBegin());
            const startTime = Date.now();
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            if (inductPackageMetricsMap) {
                dispatch(loadInductPackageMetricsForAisle(inductPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForAisleCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForAisleCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowAssociateMetricsForAisle = (nodeId, cycles, clusters) => {

    const metricName = "getStowAssociateMetrics";

    const request = {
        groupBy: Resource.AISLE,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            AssociateMetric.ACTIVE_ASSOCIATE_COUNT,
            AssociateMetric.INACTIVE_ASSOCIATE_COUNT
        ]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForAisleCallBegin());
            const startTime = Date.now();
            const stowAssociateMetricsMap = await getStowAssociateMetrics(request);
            if (stowAssociateMetricsMap) {
                dispatch(loadStowAssociateMetricsForAisle(stowAssociateMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForAisleCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForAisleCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/AisleActions.js